<mat-dialog-content class="mat-typography">
  <spt-terms-and-conditions></spt-terms-and-conditions>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>
